module.exports = __webpack_public_path__ + "static/media/leafly_bw.904a5084.png";